import React from 'react';
import './FundNoteTip.scss';
import { isCollegeAnything } from '../../../../utils/transactions-util';
import words from '../../../../utils/words';
import downloadIcon from '../../../../assets/images/Download_icon.svg';

const SignatureRequiredFundNoteTip = ({ formUrl }) => (
  <div className="exclude">
    Registration on bank and {formUrl ? 'portfolio' : `${words.fund} account`}{' '}
    do not match.{' '}
    {isCollegeAnything()
      ? 'Please complete and return form to link bank for contributions from this account.'
      : 'Submit form with medallion signature guarantee.'}
    <a
      className="fund-note-tip-link exclude college-branded-link"
      href={
        formUrl
          ? formUrl
          : 'https://individual.troweprice.com/Retail/Shared/PDFs/shrhldrsrvcs.pdf?WTAFeaturedResult=account%20services%20form'
      }
      rel="noopener noreferrer"
      target="_blank"
    >
      <img alt="download" src={downloadIcon} />
      &nbsp; Download Form
    </a>
  </div>
);

export default SignatureRequiredFundNoteTip;
